<template>
    <el-table v-if="!loading"
              :data="orderWarehouses"
              style="width: 100%"
              :height="400"
              size="middle">
        <el-table-column prop="id" label="ID" min-width="5%"></el-table-column>
        <el-table-column prop="name" label="仓库名" min-width="10%"> </el-table-column>
        <el-table-column prop="type" label="类型" min-width="10%"> </el-table-column>
    </el-table>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialogs_GetWarehouse",
        data() {
            return {
                path: '/student/list',
                loading: true,
                warehouses: '',
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                filter:{
                    storeId: 1,
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleIndexShop();
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderWarehouses: function () {
                return this._.orderBy(this.warehouses, 'id', 'asc');
            }
        },
        methods: {
            handleIndexShop() {
                this.$axios.get(store.state.server + '/getStore').then((response) => {
                    if (response.data.code == '0000') {
                        this.loading=false;
                        if (Object.keys(response.data.content.store).length !== 0) {
                            this.warehouses=response.data.content.store
                        } else {
                            this.warehouses = new Object();
                        }

                    }
                }).catch((res) => {
                    this.loading=false;
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
        }
    }
</script>

<style scoped>

</style>